import "./fooder.css";

export default function Footer() {
  return (
    <div className="Fooder">
      <a href={process.env.REACT_APP_FRONTEND_PREFIX + "/impressum"}>
        Impressum
      </a>
    </div>
  );
}
